<template>
    <div>
        <HelloWorld :loginFlag="loginFlag" :userName="userName"></HelloWorld>
        <div style="margin-top: 20px;">
            <el-tree style="width: 15%; float: left;" :data="data" :props="defaultProps" accordion @node-click="handleNodeClick">
            </el-tree>

            <div style="float: right; border-left: 1px solid red; width: 84%; line-height: 1.5;">
                <div style="width: 95%; margin: 0px auto;">
                    <!-- 运行环境 -->
                    <div v-if="this.title == ''">
                        <h2>技术支持文档</h2>
                    </div>
                    <div v-if="this.title == '运行环境'">
                        <h2>运行环境</h2>
                        <div style="margin-top: 20px;">
                            <div style="font-size: 18px;">
                                服务器配置
                            </div>
                            <div style="border-bottom: 1px solid #999999; margin-top: 10px; margin-bottom: 10px;"></div>
                            <div>
                                1、CPU：要求最低1核，推荐1核以上<br />
                                2、内存：最低要求2G，推荐2G以上<br />
                                3、带宽：推荐3Mbps以上[海外服务器适当增加]<br />
                                4、存储：20G以上<br />
                            </div>
                        </div>
                        <div style="margin-top: 20px;">
                            <div style="font-size: 18px;">
                                环境配置
                            </div>
                            <div style="border-bottom: 1px solid #999999; margin-top: 10px; margin-bottom: 10px;"></div>
                            <div>
                                1、操作系统：Linux环境（推荐CentOS 7 任意版本）<br />
                                2、宝塔面板：如果使用宝塔需要8.0以上 [宝塔非必装选项]<br />
                                3、WEB环境：Nginx1.8以上<br />
                                4、MySQL版本：必须使用MySQL8.0.24<br />
                                5、Redis版本：必须使用Redis7.2.7<br />
                                6、Java版本：必须使用1.8<br />
                            </div>
                        </div>
                        <div style="margin-top: 20px;">
                            <div style="font-size: 18px;">
                                宝塔面板安装
                            </div>
                            <div style="border-bottom: 1px solid #999999; margin-top: 10px; margin-bottom: 10px;"></div>
                            <div>
                                1、宝塔面板地址：<a href="https://www.bt.cn/new/download.html">宝塔面板地址：</a>https://www.bt.cn/new/download.html<br />
                                推荐选择自动安装Linux
                                <el-image :src="require('/src/assets/images/documentation/baotamiaban.png')" style="margin-top: 10px;"></el-image>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="this.title == '运行环境'"> -->
                    <div v-if="this.title == '环境部署'">
                        <h2>环境部署</h2>
                        <div style="margin-top: 20px;">
                            <div style="border-bottom: 1px solid #999999; margin-top: 10px; margin-bottom: 10px;"></div>
                            <div>
                                1、使用自动安装脚本<br />
                                2、上传脚本文件以及安装文件到www/wwwroot文件夹下
                                <el-image :src="require('/src/assets/images/documentation/anzhuangjiaoben.png')"></el-image>
                                3、打开终端运行脚本 在终端输入：[sh xus.sh]
                                <el-image :src="require('/src/assets/images/documentation/yxjb.png')"></el-image>
                                4、配置端口号 [6379、8585、3306]
                                <el-image :src="require('/src/assets/images/documentation/dk.png')"></el-image>
                                5、创建数据库
                                <el-image :src="require('/src/assets/images/documentation/sjkbs.png')"></el-image>
                                6、导入数据库
                                <el-image :src="require('/src/assets/images/documentation/dr1.png')"></el-image>
                                <el-image :src="require('/src/assets/images/documentation/dr2.png')"></el-image>
                                7、配置Redis
                                <el-image :src="require('/src/assets/images/documentation/rds1.png')"></el-image>
                                <el-image :src="require('/src/assets/images/documentation/rds2.png')"></el-image>
                                8、配置端口号 [6379、8585、3306]
                                <el-image :src="require('/src/assets/images/documentation/dk.png')"></el-image>
                                9、配置Nginx 配置完成后点击服务重启接口和配置Redis类似
                                <el-image :src="require('/src/assets/images/documentation/nginx.png')"></el-image>
                                10、配置项目
                                <el-image :src="require('/src/assets/images/documentation/pzwj.png')"></el-image>
                                10、配置java项目
                                <el-image :src="require('/src/assets/images/documentation/j1.png')"></el-image>
                                <el-image :src="require('/src/assets/images/documentation/j2.png')"></el-image>

                            </div>
                        </div>
                    </div>
                    <div v-if="this.title == '后台'">
                        <h2>后台使用</h2>
                        <div style="margin-top: 20px;">
                            <div style="font-size: 18px;">
                                后台账号
                            </div>
                            <div style="border-bottom: 1px solid #999999; margin-top: 10px; margin-bottom: 10px;"></div>
                            <div>
                                1、后台访问地址：通过域名或者ip进行访问 例如：xxx.com/gld或127.0.0.1/houtai<br />
                                2、首次登录您的账号和密码均为您的ip<br />
                                3、首次使用需要您输入您的ip以及您的商城密钥, 请妥善保管您的密钥，除官方工作人员外不要透露
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelloWorld from '@/components/top-bar.vue'
    export default {
        components: {
            HelloWorld
        },
        data() {
            return {
                userName: '',
                loginFlag: '',
                title: '',
                data: [{
                    label: '安装程序',
                    children: [{
                        label: '运行环境',
                    }, {
                        label: '环境部署',
                    }]
                }, {
                    label: '使用方式',
                    children: [{
                        label: '后台',
                    }, {
                        label: '二级 2-2',
                    }]
                }],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            };
        },
        mounted() {
            this.loginFlag = !localStorage.getItem('userTK') == ''
            this.userName = localStorage.getItem('userName')
        },
        methods: {
            handleNodeClick(e) {
                this.title = e.label
                console.log(e.label == '运行环境')
            }
        }
    }
</script>

<style scoped>
</style>